import(/* webpackMode: "eager" */ "/build/apps/web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\",\"cyrillic\",\"greek\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/build/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/build/apps/web/src/components/cookie-consent-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/build/apps/web/src/providers/providers.tsx");
